export const COLORS = {
  mainGreen: '#658354',
};
